/**
 * Desktop workspace panel — Phase 9.
 *
 * Sticky right-column container holding the project's current state
 * (project details, photos, measurements, design, preliminary
 * estimate). Renders at md:+ only; the mobile path uses
 * MobileWorkspaceDrawer.
 *
 * The panel sticks to `top: 5rem` (page header) and caps its own
 * height at the viewport so card overflow scrolls inside the panel
 * rather than pushing content off-screen.
 */

import type { ReactNode } from "react";

interface Props {
  children: ReactNode;
  /** Optional admin-only block rendered below an "Admin tools"
   * divider. Customer-facing pages pass `undefined`. */
  adminTools?: ReactNode;
}

export function WorkspacePanel({ children, adminTools }: Props) {
  return (
    <aside
      aria-label="Project workspace"
      className="hidden md:block md:sticky md:top-20 md:max-h-[calc(100vh-6rem)] md:overflow-y-auto md:space-y-4 md:pr-1"
    >
      {children}
      {adminTools && (
        <>
          <div className="flex items-center gap-3 pt-4">
            <div className="h-px flex-1 bg-starz-gold/20" />
            <span className="text-[11px] font-semibold uppercase tracking-widest text-starz-gold">
              Admin tools
            </span>
            <div className="h-px flex-1 bg-starz-gold/20" />
          </div>
          <div className="space-y-4">{adminTools}</div>
        </>
      )}
    </aside>
  );
}
